import QrCodeThumb from "../components/QrCodeThumb"
import { useDefaultTableStyling as sytlingOptions } from "./globalStyle"
export default function locationDataColumn(groupsMenus, onQRCodeSelected) {
    let mapped = groupsMenus.map(item => ({ [item.val]: item.text }))
    let groupItems = Object.assign({}, ...mapped)
    const columns = [
        { title: 'Groups', field: 'idGroup', lookup: groupItems },
        { title: 'Location', field: 'description' },
        { title: 'IVR description', field: 'shortDescription' },
        {
            title: "QR Code",
            field: "qrCode",
            width: "5%",
            render: (rowdata) => {
              //if(rowdata.qrCode)  console.log('Program Id', rowdata.idProgram,rowdata.qrCode)
             
              return(
                <div style={{width:'30px'}}>
                  <QrCodeThumb url={rowdata?.qrCode} onClick={() => onQRCodeSelected(rowdata)}/>
                </div>
              )
            }
        }

    ]
    // const columns = [
    //     {
    //         title: Strings.COLUMN_GROUP, field: 'idGroup', lookup: groupItems,
    //         render: (rowdata) => rowdata.idGroup === 0 ? "No Group" : rowdata.idGroup,
    //     },
    //     {
    //         title: Strings.COLUMN_LOCATION, field: 'description',
    //         render: (rowdata) => rowdata.idMerchant === 0 ? "No Location" : rowdata.description
    //     }
    // ]

    return { columns, sytlingOptions }
    
}